export enum MedicareQuotesType {
  MEDICARE_SUPPLEMENT = 'medicareSupplement',
  MEDICARE_ADVANTAGE = 'medicareAdvantage',
  MEDICARE_PRESCRIPTION = 'medicarePrescription',
  MEDICARE_NON_SUPPLEMENT = 'medicareNonSupplement'
}
